export function getBestBannerSize(bannerSizeBreakpoints, windowSize) {
  for (let i = 0, length = bannerSizeBreakpoints.length; i < length; i++) {
    const breakpoint = bannerSizeBreakpoints[i];
    const breakpointDiff = breakpoint[0] - windowSize[0];

    if (breakpointDiff < -1) {
      return breakpoint;
    }
  }

  return null;
}
